import { render, staticRenderFns } from "./PDFJSViewer.vue?vue&type=template&id=472dd42a&scoped=true&"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js&"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js&"
import style0 from "./PDFJSViewer.vue?vue&type=style&index=0&id=472dd42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dd42a",
  null
  
)

export default component.exports